// extracted by mini-css-extract-plugin
export var base = "toggle-module--base--a3105";